export default __webpack_public_path__ + "static/Raizen-3fbefdddb36727733f3e2c9f78b3dd71.png";